import { AxiosPromise } from 'axios';
import { AxiosConfig, BaseService } from './BaseService';
import { resources } from '../resources';
import { VisitationAnalyticsQueryParams } from '../params/VisitationAnalyticsQueryParams';
import { AnalyticsResponseDto } from '../models/analytics/AnalyticsResponseDto';

export class VisitationAnalyticsService extends BaseService {
  public visitationsAnalytics(args?: VisitationAnalyticsQueryParams, options: AxiosConfig = {}): AxiosPromise<AnalyticsResponseDto> {
    return this.get<AnalyticsResponseDto>(resources.visitationsAnalytics, args, options);
  }

  public visitationsAnalyticsExport(
    args?: VisitationAnalyticsQueryParams & { format?: string; paged?: boolean },
    options: AxiosConfig = {},
  ): AxiosPromise<Blob> {
    return this.get<Blob>(resources.visitationsAnalyticsExport, args, { responseType: 'blob', ...options });
  }
}
